import React, { Suspense, lazy } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Loading from "./page/Loading";
const Login = lazy(() => import("./page/Login"));
const Template = lazy(() => import("./page/template"));
const TemplateDocument = lazy(() => import("./document/template"));

const Notfound = lazy(() => import("./page/notfound"));

const Dashboard = lazy(() => import("./page/admin/dashboard")); // หน้าหลัก

// ตั้งค่า
const Banks = lazy(() => import("./page/admin/setting/banks")); // บัญชีธนาคาร
const Barcodes = lazy(() => import("./page/admin/setting/barcodes")); // บาร์โค้ด 
const Categories = lazy(() => import("./page/admin/setting/categories")); // หมวดหมู่ 
const Companies = lazy(() => import("./page/admin/setting/companies")); // บริษัทที่จำหน่าย 
const CreateUpdateCustomers = lazy(() => import("./page/admin/setting/create-update-customers")); // สร้าง/แก้ไข ลูกค้า
const Customers = lazy(() => import("./page/admin/setting/customers")); // ลูกค้า
const PrintBarcodes = lazy(() => import("./page/admin/setting/print-barcodes")); // พิมพ์บาร์โค้ด
const Roles = lazy(() => import("./page/admin/setting/roles")); // บทบาท
const SpareParts = lazy(() => import("./page/admin/setting/spare-parts")); // อะไหล่และการซ่อม
const Users = lazy(() => import("./page/admin/setting/users")); // ผู้ใช้งาน 
const Warehouses = lazy(() => import("./page/admin/setting/warehouses")); // คลังสินค้า

// สต็อก
const ReceiveGoods = lazy(() => import("./page/admin/stock/receive-goods")); // รับสินค้า 
const CreateUpdateReceiveGoods = lazy(() => import("./page/admin/stock/create-update-receive-goods")); // รับสินค้า 
const ReturnCustomerGoods = lazy(() => import("./page/admin/stock/return-customer-goods")); // คืนสินค้าจากลูกค้า
const ReturnGoods = lazy(() => import("./page/admin/stock/return-goods")); // คืนสินค้าให้ Sup
const StockChecks = lazy(() => import("./page/admin/stock/stock-checks")); // เช็คสต็อก
const StockHistories = lazy(() => import("./page/admin/stock/stock-histories")); // ประวัติสต็อก
const StockLists = lazy(() => import("./page/admin/stock/stock-lists")); // สต็อกสินค้า
const WithdrawalGoods = lazy(() => import("./page/admin/stock/withdrawal-goods")); // เบิกสินค้า

// ขาย
const Pos = lazy(() => import("./page/admin/sale/pos")); // บันทึกรายการขาย

// รับชำระ
const OrderLists = lazy(() => import("./page/admin/payment/order-lists")); // รายการสั่งซื้อ
const Payments = lazy(() => import("./page/admin/payment/payments")); // รับชำระ
const PaymentLists = lazy(() => import("./page/admin/payment/payments-lists")); // รายการชำระเงิน
const Histories = lazy(() => import("./page/admin/payment/history-lists")); // รายการใบแจ้งหนี้

// ใบแล้วหนี้/ใบวางบิล 
const Invoices = lazy(() => import("./page/admin/invoice/invoices")); // รายการใบแจ้งหนี้
const PaymentInvoices = lazy(() => import("./page/admin/invoice/payment-invoices")); // รับชำระใบวางบิล
const Billings = lazy(() => import("./page/admin/invoice/billings")); // ใบวางบิล 
const CreateBillings = lazy(() => import("./page/admin/invoice/create-billings")); // รับชำระใบวางบิล
const PaymentBillings = lazy(() => import("./page/admin/invoice/payment-billings")); // รับชำระใบวางบิล
const DebtReduces = lazy(() => import("./page/admin/invoice/debt-reduces")); // ใบลดหนี้
const PaymentDebtReduces = lazy(() => import("./page/admin/invoice/payment-debt-reduces")); // ใบลดหนี้

// การซ่อม
const DetailRepairs = lazy(() => import("./page/admin/repair/detail-repairs")); // ข้อมูลใบแจ้งซ่อม 
const Repairs = lazy(() => import("./page/admin/repair/repairs")); // รายการใบแจ้งซ่อม
const UpdateCost = lazy(() => import("./page/admin/repair/update-cost")); // แก้ไขต้นทุน

// PDF
const DeliveryTaxInvoice = lazy(() => import("./document/delivery-tax-invoice")); // รายการใบแจ้งซ่อม
const ReceiptTax = lazy(() => import("./document/receipt-tax")); // ใบรับ
const Receipt = lazy(() => import("./document/receipt")); // ใบรับ
const ProductReceipt = lazy(() => import("./document/product-receipt")); // ใบรับสินค้า
const CarReceipt = lazy(() => import("./document/car-receipt")); // ใบรับงาน
const ReturnClaim = lazy(() => import("./document/return-claim")); // ใบคืน/เคลมสินค้าผู้จำหน่าย
const ReturnProduct = lazy(() => import("./document/return-product")); // ใบคืนสินค้า
const ChangeProduct = lazy(() => import("./document/change-product")); // ใบเปลี่ยนสินค้า
const Repair = lazy(() => import("./document/repair")); // รายการซ่อม
const GetSpareParts = lazy(() => import("./document/get-spare-parts")); // บิลเบิกอะไหล่ ซ่อม-ติดตั้ง
const DocBilling = lazy(() => import("./document/billing")); // ใบวางบิล
const Quotation = lazy(() => import("./document/quotation")); // ใบเสนอราคา
const Deposit = lazy(() => import("./document/deposit")); // ใบมัดจำสินค้า
const Loan = lazy(() => import("./document/loan")); // ใบยืมสินค้า
const Contract = lazy(() => import("./document/contract")); // ใบสัญญายืมหรือซื้อสินค้าชั่วคราว
const CreditNote = lazy(() => import("./document/credit-note")); // ใบลดหนี้
const InstallationSummary = lazy(() => import("./document/installation-summary")); // ใบสรุปรายการติดตั้ง
const DeliveryNote = lazy(() => import("./document/delivery-note")); // ใบส่งของ

// รายงาน
const ReportStatusDebtors = lazy(() => import("./page/admin/report/status-debtors")); // รายการสถานะลูกหนี้
const ReportDialyDebtors = lazy(() => import("./page/admin/report/dialy-debtors")); // รายการต่อวันเฉพาะลูกหนี้
const ReportOrderLists = lazy(() => import("./page/admin/report/order-lists")); // รายการสั่งซื้อ
const ReportDepositLists = lazy(() => import("./page/admin/report/deposit-lists")); // รายการมัดจำ
const ReportPaymentLists = lazy(() => import("./page/admin/report/payment-lists")); // รายการชำระเงิน
const ReportRepairs = lazy(() => import("./page/admin/report/repairs")); // รายการแจ้งซ่อม
const ReportInvoices = lazy(() => import("./page/admin/report/invoices")); // รายการใบแจ้งหนี้
const ReportBillings = lazy(() => import("./page/admin/report/billings")); // รายการใบวางบิล
const ReportDebtReduces = lazy(() => import("./page/admin/report/debt-reduces")); // รายการใบลดหนี้
const ReportWithdrawalGoods = lazy(() => import("./page/admin/report/withdrawal-goods")); // รายการเบิก
const ReportUpdateCost = lazy(() => import("./page/admin/report/update-cost")); // รายงานต้นทุนซื้อ
const ReportSale = lazy(() => import("./page/admin/report/sales")); // รายงานขาย
const ReportSaleItems = lazy(() => import("./page/admin/report/sale-items")); // รายงานขายแยกรายสินค้า
const ReportReceiveGoods = lazy(() => import("./page/admin/report/receive-goods")); // รายงานรับสินค้า
const ReportConsolidatedGoods = lazy(() => import("./page/admin/report/consolidated-goods")); // รายงานรับสินค้าแบบรวม
const ReportSupplierReturn = lazy(() => import("./page/admin/report/supplier-return")); // รายงานคืนสินค้าให้ supplier
const ReportCustomerReturn = lazy(() => import("./page/admin/report/customer-return")); // รายงานคืนสินค้าลูกค้า
const ReportCostUpdate = lazy(() => import("./page/admin/report/cost-update")); // รายงานอัปเดทต้นทุน
// รายงานรับสินค้าแบบละเอียด
// รายงานรับสินค้าแบบรวม
// รายงานคืนสินค้าให้ sup
// รายงานเบิกสินค้า
// รายงานคืนสินค้าจากลูกค้า
// รายงานขายสินค้า
// รายงานมัดจำ
// รายงานสต็อกคงเหลือ
// รายงานเช็คสต็อก
// รายงานใบแจ้งซ่อม
// รายงานใบแจ้งหนี้
// รายงานใบวางบิล

// PDF

const PDFBarcode = lazy(() => import("./document/barcode"));

// แต่ละหน้าแยกไฟล์ (code splitting) โหลดเฉพาะหน้าที่เปิด ไม่ต้องโหลดทั้งแอป 8 MB ทุกครั้ง
const AppRoutes = () => (
<Suspense fallback={null}>
<Routes>
<Route path="/" element={<Loading />} />
<Route path="/login" element={<Login />} />
<Route path="/template" element={<Template />} />
<Route path="/document/template" element={<TemplateDocument />} />

<Route path="/dashboard" element={<Dashboard />} /> {/* บัญชีธนาคาร */}

<Route path="/setting/banks" element={<Banks />} /> {/* บัญชีธนาคาร */}
<Route path="/setting/barcodes" element={<Barcodes />} /> {/* บาร์โค้ด */}
<Route path="/setting/categories" element={<Categories />} /> {/* หมวดหมู่ */}
<Route path="/setting/companies" element={<Companies />} /> {/* บริษัทที่จำหน่าย */}
<Route path="/setting/customers/create" element={<CreateUpdateCustomers />} /> {/* สร้างลูกค้า */}
<Route path="/setting/customers/update" element={<CreateUpdateCustomers />} /> {/* แก้ไขลูกค้า */}
<Route path="/setting/customers" element={<Customers />} /> {/* ลูกค้า */}
<Route path="/setting/print-barcodes" element={<PrintBarcodes />} /> {/* พิมพ์บาร์โค้ด */}
<Route path="/setting/roles" element={<Roles />} /> {/* บทบาท */}
<Route path="/setting/spare-parts" element={<SpareParts />} /> {/* อะไหล่และการซ่อม */}
<Route path="/setting/users" element={<Users />} /> {/* ผู้ใช้งาน */}
<Route path="/setting/warehouses" element={<Warehouses />} /> {/* คลังสินค้า */}

<Route path="/stock/receive-goods" element={<ReceiveGoods />} /> {/* รับสินค้า */}
<Route path="/stock/receive-goods/view" element={<CreateUpdateReceiveGoods />} /> {/* รายละเอียดรับสินค้า */}
<Route path="/stock/receive-goods/create" element={<CreateUpdateReceiveGoods />} /> {/* สร้างรับสินค้า */}
<Route path="/stock/receive-goods/update" element={<CreateUpdateReceiveGoods />} /> {/* แก้ไขรับสินค้า */}
<Route path="/stock/return-customer-goods" element={<ReturnCustomerGoods />} /> {/* คืนสินค้าจากลูกค้า */}
<Route path="/stock/return-goods" element={<ReturnGoods />} /> {/* คืนสินค้าให้ Sup */}
<Route path="/stock/stock-checks" element={<StockChecks />} /> {/* เช็คสต็อก */}
<Route path="/stock/stock-histories" element={<StockHistories />} /> {/* ประวัติสต็อก */}
<Route path="/stock/stock-lists" element={<StockLists />} /> {/* สต็อกสินค้า  */}
<Route path="/stock/withdrawal-goods" element={<WithdrawalGoods />} /> {/* เบิกสินค้า */}

<Route path="/sale/pos" element={<Pos />} /> {/* บันทึกรายการขาย  */}

<Route path="/payment/order-lists" element={<OrderLists />} /> {/* รายการสั่งซื้อ */}
<Route path="/payment/payments" element={<Payments />} /> {/* รับชำระ */}
<Route path="/payment/payments-lists" element={<PaymentLists />} /> {/* รายการชำระเงิน */}
<Route path="/payment/history-lists" element={<Histories />} /> {/* รายการใบแจ้งหนี้ */}

<Route path="/invoice/invoices" element={<Invoices />} /> {/* รายการใบแจ้งหนี้ */}
<Route path="/invoice/payment-invoices" element={<PaymentInvoices />} /> {/* รายการใบแจ้งหนี้ */}
<Route path="/invoice/billings" element={<Billings />} /> {/* ใบวางบิล */}
<Route path="/invoice/create-billings" element={<CreateBillings />} /> {/* รับชำระใบวางบิล */}
<Route path="/invoice/payment-billings" element={<PaymentBillings />} /> {/* รับชำระใบวางบิล */}
<Route path="/invoice/debt-reduces" element={<DebtReduces />} /> {/* ใบลดหนี้ */}
<Route path="/invoice/payment-debt-reduces" element={<PaymentDebtReduces />} /> {/* ใบลดหนี้ */}

<Route path="/repair/detail-repairs" element={<DetailRepairs />} /> {/* ข้อมูลใบแจ้งซ่อม */}
<Route path="/repair/repairs" element={<Repairs />} /> {/* รายการใบแจ้งซ่อม  */}
<Route path="/repair/update-cost" element={<UpdateCost />} /> {/* แก้ไขต้นทุน  */}

<Route path="/doc/delivery-tax-invoice" element={<DeliveryTaxInvoice />} /> {/* ใบส่งของ/ใบกำกับภาษี  */}
<Route path="/doc/receipt" element={<Receipt />} /> {/* ใบรับ */}
<Route path="/doc/receipt-tax" element={<ReceiptTax />} /> {/* ใบรับ */}
<Route path="/doc/car-receipt" element={<CarReceipt />} /> {/* ใบรับงาน */} 
<Route path="/doc/product-receipt" element={<ProductReceipt />} /> {/* ใบรับสินค้า */}
<Route path="/doc/return-claim" element={<ReturnClaim />} /> {/* ใบคืน/เคลมสินค้าผู้จำหน่าย */}
<Route path="/doc/return-product" element={<ReturnProduct />} /> {/* ใบคืนสินค้า */ }
<Route path="/doc/change-product" element={<ChangeProduct />} /> {/* ใบเปลี่ยนสินค้า */}
<Route path="/doc/repair" element={<Repair />} /> {/* รายการซ่อม */}
<Route path="/doc/get-spare-parts" element={<GetSpareParts />} /> {/* บิลเบิกอะไหล่ ซ่อม-ติดตั้ง */}
<Route path="/doc/billing" element={<DocBilling />} /> {/* ใบวางบิล */}
<Route path="/doc/quotation" element={<Quotation />} /> {/* ใบเสนอราคา */}
<Route path="/doc/deposit" element={<Deposit />} /> {/* ใบมัดจำสินค้า */}
<Route path="/doc/loan" element={<Loan />} /> {/* ใบยืมสินค้า */}
<Route path="/doc/contract" element={<Contract />} /> {/* ใบสัญญายืมหรือซื้อสินค้าชั่วคราว */}
<Route path="/doc/credit-note" element={<CreditNote />} /> {/* ใบลดหนี้ */}
<Route path="/doc/installation-summary" element={<InstallationSummary />} /> {/* ใบสรุปรายการติดตั้ง */}
<Route path="/doc/delivery-note" element={<DeliveryNote />} /> {/* ใบส่งของ */}

<Route path="/report/status-debtor-reports" element={<ReportStatusDebtors />} /> {/* รายการสถานะลูกหนี้ */}
<Route path="/report/dialy-debtors-reports" element={<ReportDialyDebtors />} /> {/* รายการต่อวันเฉพาะลูกหนี้ */}
<Route path="/report/order-list-reports" element={<ReportOrderLists />} /> {/* รายการสั่งซื้อ */}
<Route path="/report/deposit-list-reports" element={<ReportDepositLists />} /> {/* รายการมัดจำ */}
<Route path="/report/payment-list-reports" element={<ReportPaymentLists />} /> {/* รายการชำระเงิน */}
<Route path="/report/invoice-reports" element={<ReportInvoices />} /> {/* รายการใบแจ้งหนี้ */}
<Route path="/report/billing-reports" element={<ReportBillings />} /> {/* รายการใบวางบิล */}
<Route path="/report/debt-reduce-reports" element={<ReportDebtReduces />} /> {/* รายการใบลดหนี้ */}
<Route path="/report/repair-reports" element={<ReportRepairs />} /> {/* รายการแจ้งซ่อม */}
<Route path="/report/withdrawal-good-reports" element={<ReportWithdrawalGoods />} /> {/* รายการเบิก */}
<Route path="/report/update-cost-reports" element={<ReportUpdateCost />} /> {/* รายงานต้นทุนซื้อ */}
<Route path="/report/sale-reports" element={<ReportSale />} /> {/* รายงานขาย */}
<Route path="/report/sale-item-reports" element={<ReportSaleItems />} /> {/* รายงานขายแยกรายสินค้า */}
<Route path="/report/receive-good-reports" element={<ReportReceiveGoods />} /> {/* รายงานรับสินค้า */}
<Route path="/report/consolidated-good-reports" element={<ReportConsolidatedGoods />} /> {/* รายงานรับสินค้าแบบรวม */}
<Route path="/report/supplier-return-reports" element={<ReportSupplierReturn />} /> {/* รายงานคืนสินค้าให้ supplier */}
<Route path="/report/customer-return-reports" element={<ReportCustomerReturn />} /> {/* รายงานคืนสินค้าลูกค้า */}
<Route path="/report/cost-update-reports" element={<ReportCostUpdate />} /> {/* รายงานอัปเดทต้นทุน */}

<Route path="/pdf/barcode" element={<PDFBarcode />} /> {/* BARCODE  */}

<Route path="/*" element={<Notfound />} />
</Routes>
</Suspense>
);

export default AppRoutes;
